




















import { defineComponent, onBeforeMount, toRefs } from '@vue/composition-api'
import { Home } from '@/views/Home.vue'

export default defineComponent({
    name: "pagination",
    props: {
        pagination: Object
    },
    setup(props, context) {

        const handlePageChange = (page: string) => {
            const pagination = props.pagination;
            switch (page) {
                case 'next':
                    if(pagination.page + 1 < pagination.pages){
                        pagination.page = pagination.page + 1;
                    }
                break;
                case 'prev':
                    if(pagination.page > 0){
                        pagination.page = pagination.page - 1;
                    }
                break;
                case 'first':
                    pagination.page = 0;
                break;
                case 'last':
                    pagination.page = pagination.pages - 1;
                break;
            }
        }

        onBeforeMount(() => {
            props.pagination.page = 0;
        })

        return {
            ...toRefs(Home),
            handlePageChange
        }
    }
})
